"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var luxon_1 = require("luxon");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var NumberFormatter_1 = require("Utils/NumberFormatter");
var hydrationHelpers_1 = require("../hydrationHelpers");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("project-accepted-modal");
var ProjectAccepted = function (_a) {
    var acceptedAt = _a.acceptedAt;
    var dt = luxon_1.DateTime.fromISO(acceptedAt);
    var formattedDate = "".concat(dt.toFormat("MMM"), " ").concat((0, NumberFormatter_1.toOrdinalNumber)(dt.day), ", ").concat(dt.year);
    var _b = __read((0, react_1.useState)(true), 2), show = _b[0], setShow = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null, show && (react_1.default.createElement(ModalComponent_1.AcknowledgeModal, { isEscapable: true, callback: function () { return setShow(false); }, buttonLabel: "Got it!", containerClassName: "public-page-modal" },
        react_1.default.createElement("div", { className: "public-page-status-modal ".concat(c()) },
            react_1.default.createElement(AcceptedTickIcon, null),
            acceptedAt && (react_1.default.createElement("div", { className: "status-badge ".concat(c("status-badge")) },
                react_1.default.createElement(icons_1.ListMarkerCircle, { className: c("accepted-badge-marker") }), "Accepted ".concat(formattedDate))),
            react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: "This page is accepted!", explainer: "The page is still visible for your records, but you can no longer modify the quote or re-accept (if applicable). The page creator cannot edit the content." }))))));
};
var AcceptedTickIcon = function () {
    return (react_1.default.createElement("div", { className: "accepted-tick modal-icon" },
        react_1.default.createElement(icons_1.Tick, { className: "accepted-tick__icon", size: icons_1.IconSize.Large })));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(ProjectAccepted, { componentName: "ProjectAccepted" });
